import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Testimonials extends Component {
  render() {
    const {
      anchor,
      header,
      subHeader,
      copy,
      links,
    } = this.props;
    return (
      <section id={anchor || undefined} className="testimonial-wrapper">
        <span className="label">{header}</span>
        <h3>{subHeader}</h3>
        <p>{copy}</p>
        {links && links.length > 0 && (
          <Link
            className={`label ${links[0].textColor.toLowerCase()}`}
            to={links[0].destinationPage.url}
          >{links[0].text}</Link>
        )}
      </section>
    );
  }
}
